import React from "react";
import { MenuItem, Select } from "@mui/material";

// "Success"/"Pending" send the opposite status string on purpose — it cancels out
// the server's inverted booking_no TE-match logic in bookings.service.ts.
const OPTIONS = [
  { id: 2, label: "Success", status: "pending" },
  { id: 1, label: "Pending", status: "success" },
  { id: 3, label: "ALL", status: "" },
];

const BookingStatus = ({ setStatus, status, width, setPage }) => {
  const selected = OPTIONS.find((item) => item.status === status)?.id ?? "";

  return (
    <Select
      style={{ width: width || "50%", height: "40px", marginRight: "10px" }}
      required
      displayEmpty
      renderValue={selected !== "" ? undefined : () => "Booking Status"}
      value={selected}
      onChange={(e) => {
        const option = OPTIONS.find((item) => item.id === e.target.value);
        setStatus(option ? option.status : "");
        setPage(1);
      }}
    >
      {OPTIONS.map((item) => (
        <MenuItem key={item.id} value={item.id}>
          {item.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default BookingStatus;
